<template>
  <div class="container">
    <div class="row">
      <div class="col-12">
        <h1>Add Service</h1>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <b-card class="mt-3">
          <service-form @submit="submit"></service-form>
        </b-card>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import ServiceForm from './ServiceForm';

export default {
  components: {
    ServiceForm
  },
  methods: {
    ...mapActions({
      createService: 'services/createService'
    }),
    async submit(service) {
      try {
        await this.createService(service);
        this.$notify({
          type: 'success',
          text: 'Service added'
        });
        this.$router.push({ name: 'services' });
      } catch (e) {
        this.$notify({
          type: 'error',
          title: 'Error',
          text: e.message
        });
      }
    }
  }
};
</script>
